import {
  Auth_Login as logIn,
  Auth_Refresh as refreshToken,
  Auth_RegisterBackOfficeUser as register,
} from './backend'

//with credentials is ONLY needed
//when calling login or refresh
//as refresh tokens are HTTP ONLY cookies
//to protect the refresh tokens against XSS attacks

const login = async (usr, pwd) => {
  let {data} = await logIn({
    cmd: {
      userName: usr,
      password: pwd,
    },
    $config: {
      withCredentials: true,
    },
  })
  return data
}

const refresh = async token => {
  let {data} = await refreshToken({
    cmd: {
      accessToken: token,
    },
    $config: {
      withCredentials: true,
    },
  })
  return data
}

const registerUser = async req => {
  let {data} = await register({
    cmd: {...req},
  })
  return data
}

const parseJwt = token => {
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )

  return JSON.parse(jsonPayload)
}

export default {
  login,
  refresh,
  parseJwt,
  registerUser,
}
